
import axios from "axios";

const API_URL = "https://api.gestionstockvalc.fr";
// const API_URL = "http://localhost:8000";

export const API_ROUTES = {
    IMG: `${API_URL}/storage/products/`,

    PRODUCTS: "/products",
    CARDS: "/cards",
    POSTERS: "/posters",
    BOOKS: "/books",
    FIGURES: "/figures",
    GOODIES: "/goodies",
    MULTIMEDIA: "/multimedia",

    TYPES: "/types",
    SUBTYPES: "/subtypes",
    PACKAGING: "/packaging",
    LICENSECARDS: "/license-cards",
    TYPELINKS: "/type-links",
    LANGUAGES: "/languages",

    UNITYCARDS: "/unity-cards",
    SOLDEDCARDS: "/solded-cards",
    QUALITYCARDS: "/quality-cards",
    RARITYCARDS: "/rarity-cards",
    COLLECTIONS: "/collections",
    EXTENSIONS: "/extensions",

    USERS: "/users",
    REGISTER: "/register",
    FORGETPASSWORD: "/forgot-password",
    LOGIN: "/login",
    LOGOUT: "/logout",
};

// Instance Axios centralisée
export const api = axios.create({
    baseURL: API_URL + "/api",  // http://127.0.0.1:8000/api
    headers: {
        "Content-Type": "application/json",
    },
    withCredentials: true,
});

function parseJwt(token) {
    try {
        const base64Payload = token.split('.')[1]; // partie payload
        const payload = atob(base64Payload);      // décodage base64
        return JSON.parse(payload);               // conversion en objet
    } catch (e) {
        return null;
    }
}

// Intercepteur pour ajouter le token si présent
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;

        const payload = parseJwt(token);
        if (payload && payload.sub) {
            localStorage.setItem("role", payload.sub); // stocker l'ID pour le front
        }
    } else {
        delete config.headers.Authorization;
        localStorage.removeItem("role");
    }

    return config;
});
